import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoHangBinhChon } from 'src/app/shared/LoHangBinhChon.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class LoHangBinhChonService extends BaseService{

    DisplayColumns001: string[] = ['ID', 'ParentID', 'Name', 'DangKy'];
        
    List: LoHangBinhChon[] | undefined;
    ListFilter: LoHangBinhChon[] | undefined;
    FormData!: LoHangBinhChon;
    
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "LoHangBinhChon";
    }
}

